import { Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import DashboardMyAccounts from '../components/dashboard/DashboardMyAccounts';

function DashboardHome(props: any) {
    return (
        <Container maxWidth={false} sx={{ paddingTop: 1, paddingBottom: 1, minHeight: '100%' }}>
            <Outlet />

            <DashboardMyAccounts />
        </Container>
    );
}

export default DashboardHome;
